import { useMemo } from "react";

import useLeadScoringConfigQuery from "app/pages/sales-intelligence/modules/lead-scoring-agent/query/queries/useLeadScoringConfigQuery";
import { useRawUISignalsGroupedById } from "app/pages/sales-intelligence/sub-modules/signals/hooks/useUISignals";
import type { ScoringConfigType } from "app/pages/sales-intelligence/sub-modules/signals/types/scoring-config";
import { translateSignalsToMapById } from "app/pages/sales-intelligence/sub-modules/signals/utils/translateSignalsToMapById";

export const useScoringBoardData = (configType: ScoringConfigType) => {
    const { data, isFetching, isError, refetch } = useLeadScoringConfigQuery(configType);
    const rawUISignals = useRawUISignalsGroupedById();

    const signalById = useMemo(() => translateSignalsToMapById(Object.values(rawUISignals)), [rawUISignals]);

    const rules = data?.rules ?? {};
    const isInitialLoading = isFetching && data === undefined;

    return {
        data,
        rules,
        signalById,
        isFetching,
        isError,
        refetch,
        isInitialLoading,
    };
};
